module.exports = __webpack_public_path__ + "static/media/soils_example_2_1.3473c79f.png";


//////////////////
// WEBPACK FOOTER
// ./public/stem_soils_images/soils_example_2_1.png
// module id = 1282
// module chunks = 0